export const isReadOnly: boolean = true;